import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../loading/Loading";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiHash, FiFileText, FiPackage } from 'react-icons/fi';
import FormLayout, { SubmitBtn } from '../../ui/FormLayout';
import { InputField } from '../../ui/InputField';

const AlterarUnidade = () => {
    const [sigla, setSigla] = useState('');
    const [descricao, setDescricao] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const parametro = useParams();

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    useEffect(() => {
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": parametro.id })
        };
        fetch(Apis.urlListarOneUnidades, requestOptions)
            .then(response => response.json())
            .then((result) => {
                if (result.retorno.sucesso) {
                    setDescricao(result.registros[0].descricao);
                    setSigla(result.registros[0].sigla);
                } else {
                    alertaErro(result.retorno.mensagem);
                    navigate("/listar-unidades");
                }
                setLoading(false);
            });
    }, []);

    const handleSubmit = () => {
        setLoading(true);
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": parametro.id, "sigla": sigla, "descricao": descricao })
        };
        fetch(Apis.urlAlterarUnidade, requestOptions)
            .then(response => response.json())
            .then((result) => {
                if (result.retorno.sucesso) {
                    navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-unidades`);
                } else {
                    alertaErro(result.retorno.mensagem);
                }
                setLoading(false);
            });
    };

    if (loading) return <Loading />;

    return (
        <FormLayout
            title="Alteração de Unidade"
            icon={<FiPackage />}
            subtitle="Atualize a sigla e descrição da unidade."
        >
            <InputField
                label="Sigla" icon={<FiHash />} required
                placeholder="Ex: KG, UN, PC"
                onChange={e => setSigla(e.target.value)} value={sigla}
            />
            <InputField
                label="Descrição" icon={<FiFileText />}
                placeholder="Descrição da unidade"
                onChange={e => setDescricao(e.target.value)} value={descricao}
            />
            <SubmitBtn onClick={handleSubmit}>Salvar Alterações</SubmitBtn>
        </FormLayout>
    );
};

export default AlterarUnidade;
